<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectCategories" });
import { SelectMultiple } from "../../../../selects/index.js";
import * as API from "../../services/api.js";
import { SESSION_USER } from "../../../authentication/services/store.js";
export let keys;
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
export let states = [];
export let verticalCode = "fashion-and-accessories";
export let whitelist = [];
export let label = "resource.category.plural.label";
export let name = "category.keys";
export let placeholder = "";
export let hint = void 0;
const LANGUAGE_CODE = $SESSION_USER?.locale.languageCode ?? "EN";
const LIMIT = 5e3;
let options = [];
$: parameters = { limit: LIMIT, states, verticalCode: verticalCode === void 0 ? [] : [verticalCode] };
const getLabel = (category) => {
    const NAME = category.name.find(({ languageCode }) => languageCode === LANGUAGE_CODE);
    if (!NAME) {
        console.error(`No localized name found for category ${category._.key}`);
        return "NAME MISSING";
    }
    return NAME.text;
};
const setLocalizedName = (category) => ({
    key: category._.key,
    label: getLabel(category),
    parentKey: category.parentKey
});
const getAncestorKeys = (startKey, parentByKey, limit) => {
    const KEYS = [];
    let currentKey = startKey;
    let guard = 0;
    while (currentKey !== void 0 && guard < limit) {
        KEYS.push(currentKey);
        currentKey = parentByKey.get(currentKey);
        guard += 1;
    }
    return KEYS;
};
const getAllowedKeys = (categories) => {
    if (whitelist.length === 0) {
        return new Set(categories.map((category) => category._.key));
    }
    const PARENT_BY_KEY = new Map(categories.map((category) => [
        category._.key,
        category.parentKey
    ]));
    const ALLOWED_KEYS = /* @__PURE__ */ new Set();
    for (const KEY of whitelist) {
        for (const ANCESTOR_KEY of getAncestorKeys(KEY, PARENT_BY_KEY, categories.length)) {
            ALLOWED_KEYS.add(ANCESTOR_KEY);
        }
    }
    return ALLOWED_KEYS;
};
const format = (categories) => {
    const ALLOWED_KEYS = getAllowedKeys(categories);
    return categories.filter((category) => ALLOWED_KEYS.has(category._.key)).filter((category) => category.name !== void 0).map(setLocalizedName);
};
const fetchCategoryOptions = (params) => {
    void API.filterCategories(params).then((categories) => {
        if (Array.isArray(categories) && categories.length > 0) {
            options = format(categories);
        }
        else {
            options = [];
        }
    });
};
$: fetchCategoryOptions(parameters);
</script>

<SelectMultiple
    bind:keys
    { name }
    { options }
    { label }
    { minItems }
    { maxItems }
    { isDisabled }
    { placeholder }
    { hint }
    hasSearch = { false }
/>